import useSWRImmutable from 'swr'
import fetcher from './fetcher'

export default function useNews(stockId) {
  const { data, error, isLoading } = useSWRImmutable(`/react/news?stock_id=${stockId}`, fetcher)

  return {
    news: data,
    isLoading,
    error
  }
}